// Helpers shared by the activity log screens (OrderLogs, order details log tab)

export const getAction = (url) => {
  const tmp = url.split('/');
  const action = tmp[tmp.length-1].split('?');
  if(isNaN(action))
    return action[0];
  else
    return tmp[tmp.length-2];
}

export const getUser = (info) => {
  if(!info)
    return 'Guest';
  try {
    const tmp = JSON.parse(info);
    return tmp.id + ' ' + tmp.email + ' ' + tmp.mobile + ' ' + (tmp.roles || []).join('*');
  } catch (e) {
    return info;
  }
}
